export default __webpack_public_path__ + "static/media/Screenshot_4.eaf260d4.png";